var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-progress-bar",class:[
        _vm.cssClasses,
        { 'cf-c-progress-bar--is-micro': _vm.micro },
        { 'cf-c-progress-bar--is-thick': _vm.thick }
    ]},[_c('div',{staticClass:"cf-c-progress-bar__progress",style:(`width: ${_vm.value}%`)},[(_vm.showProgress)?_c('span',[_vm._v(_vm._s(_vm.value)+"%")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }